import { create } from 'zustand';
import { createStaffOrdersSlice } from './staffStore/staffOrdersStore.js';
import { createStaffMenuSlice } from './staffStore/staffMenuStore.js';

export const useStaffStore = create((set, get) => ({
  ...createStaffOrdersSlice(set, get),
  ...createStaffMenuSlice(set, get)
}));